import { SquaresFour } from "@phosphor-icons/react";

function Card({ testId, icon: Icon, label, description, count, active, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={`text-left p-4 border transition-all group flex flex-col gap-2.5 ${
        active
          ? "border-primary bg-primary/5"
          : "border-slate-200 bg-white hover:border-slate-300 hover:shadow-sm"
      }`}
    >
      <div
        className={`w-9 h-9 flex items-center justify-center flex-shrink-0 ${
          active ? "bg-primary text-white" : "bg-slate-100 text-slate-500 group-hover:bg-primary/8 group-hover:text-primary"
        }`}
      >
        <Icon size={18} weight={active ? "fill" : "regular"} />
      </div>
      <div>
        <p className={`text-sm font-bold tracking-tight ${active ? "text-primary" : "text-slate-900"}`}>{label}</p>
        <p className="text-xs text-slate-500 mt-0.5 leading-snug">{description}</p>
      </div>
      <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mt-auto pt-1">
        {count} article{count === 1 ? "" : "s"}
      </span>
    </button>
  );
}

export default function CategoryCards({ categories, counts, totalCount, activeCategory, onCategoryClick }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="help-categories-grid">
      <Card
        testId="help-category-card-all"
        icon={SquaresFour}
        label="All Categories"
        description="Browse every article"
        count={totalCount}
        active={activeCategory === "all"}
        onClick={() => onCategoryClick("all")}
      />
      {categories.map((category) => (
        <Card
          key={category.id}
          testId={`help-category-card-${category.id}`}
          icon={category.icon}
          label={category.label}
          description={category.description}
          count={counts[category.id] || 0}
          active={activeCategory === category.id}
          onClick={() => onCategoryClick(category.id)}
        />
      ))}
    </div>
  );
}
